import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiArrowLeft, FiEdit2 } from 'react-icons/fi';
import { PageHeader } from 'components/admin';
import { Button } from 'components/common';
import { getAdminLeaderById } from 'apis/adminLeaders';
import { useActiveLanguagesQuery, useAdminDetailQuery } from 'hooks';
import '../../../styles/admin-shared.scss';
import { normalizeLeaderPositions } from 'utils/leaderHelpers';

const LeadersDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const { data: languages = [] } = useActiveLanguagesQuery();
    const { data: leader, isFetching, error } = useAdminDetailQuery('leaders', id, getAdminLeaderById);
    const activeLanguage = languages[activeTab];
    const translation = leader?.translation?.find((item) => Number(item.languageId) === Number(activeLanguage?.id)) || {};
    const informationItems = [...(leader?.informationItems || [])].sort((first, second) => (Number(first.sortOrder) || 0) - (Number(second.sortOrder) || 0));

    return (
        <div className="admin-page">
            <PageHeader
                title="Chi tiết lãnh đạo"
                subtitle="Xem toàn bộ hồ sơ và các phần thông tin theo ngôn ngữ"
                action={<div className="action-buttons"><Button variant="secondary" onClick={() => navigate('/admin/leaders')}><FiArrowLeft /> Quay lại</Button><Button onClick={() => navigate(`/admin/leaders/edit/${id}`)}><FiEdit2 /> Chỉnh sửa</Button></div>}
            />
            {isFetching ? <div className="form-card">Đang tải dữ liệu...</div> : error || !leader ? (
                <div className="form-card error-message">Không tải được thông tin lãnh đạo.</div>
            ) : (
                <div className="form-card leader-admin-detail">
                    <div className="leader-admin-detail__hero">
                        <div className="leader-admin-detail__image">
                            {leader.image ? <img src={leader.image} alt={leader.name || ''} /> : <span>{leader.name?.[0] || '?'}</span>}
                        </div>
                        <div>
                            <span className={`status-badge ${leader.isActive ? 'active' : 'inactive'}`}>{leader.isActive ? 'Hoạt động' : 'Không hoạt động'}</span>
                            <h2>{leader.name}</h2>
                            <p>Slug: {leader.slug || '—'} · Thứ tự: {leader.sortOrder ?? 0}</p>
                        </div>
                    </div>

                    <div className="translation-tabs">
                        <div className="tab-header">
                            {languages.map((language, index) => <button key={language.id} type="button" className={`tab-btn ${activeTab === index ? 'active' : ''}`} onClick={() => setActiveTab(index)}>{language.name} ({language.code})</button>)}
                        </div>
                    </div>

                    <section className="leader-admin-detail__section">
                        <h3>Chức vụ</h3>
                        <div className="leader-admin-detail__tags">{normalizeLeaderPositions(translation.positions).map((position, index) => <span key={index}>{position}</span>)}</div>
                        {translation.education && <p><strong>Học vấn:</strong> {translation.education}</p>}
                    </section>
                    {translation.summary && <section className="leader-admin-detail__section"><h3>Tóm tắt</h3><div className="quill-content" dangerouslySetInnerHTML={{ __html: translation.summary }} /></section>}
                    {translation.description && <section className="leader-admin-detail__section"><h3>Mô tả</h3><div className="quill-content" dangerouslySetInnerHTML={{ __html: translation.description }} /></section>}

                    <section className="leader-admin-detail__section">
                        <h3>Các phần thông tin</h3>
                        {informationItems.length ? informationItems.map((item, index) => {
                            const itemTranslation = (item.translation || []).find((entry) => Number(entry.languageId) === Number(activeLanguage?.id)) || {};
                            return <article className="leader-admin-detail__information" key={item.id || index}><div><strong>{itemTranslation.title || `Phần ${index + 1}`}</strong><span>Thứ tự {item.sortOrder || 0}</span></div><div className="quill-content" dangerouslySetInnerHTML={{ __html: itemTranslation.description || '<p>Chưa có nội dung</p>' }} /></article>;
                        }) : <p className="field-help">Chưa có phần thông tin bổ sung.</p>}
                    </section>
                </div>
            )}
        </div>
    );
};

export default LeadersDetail;
